import React from 'react';

const Goalslib=()=>{
    return(
        <div>
            <h3>OBIETTIVI</h3>
            <div className="jumbotron"><h4>Coming soon...</h4></div>
        </div>
    )
}
export default Goalslib;